// extracted by css-extract-rspack-plugin
export default {"addButton":"yBLYW","dropdown":"f6Efs","dimensionPicker":"Kf9KX"};